export default "__VITE_ASSET__dNJ2eUzp__"